import { useTranslation } from 'react-i18next';

import { TavoliMiei } from '@/components/gamehost/TavoliMiei';
import type { EtichetteTavoli, RisultatoTavoli } from '@/components/gamehost/TavoliMiei';
import { POSTI_SCOPA, POSTI_SCOPONE } from '@/lib/scopa/gioco';
import { scopaApi } from '@/services/limuloScopa';

/**
 * La lettura dei miei tavoli: la `scopaApi.useGetMyScopaTablesQuery` del SUO servizio, come una FUNZIONE DI MODULO (stabile) che la lobby comune chiama a ogni render. Le letture non restano
 * in cache oltre la schermata (`keepUnusedDataFor: 0` nel servizio), e `refetchOnMountOrArgChange` la rifa a ogni apertura.
 */
const useTavoli = (): RisultatoTavoli => scopaApi.useGetMyScopaTablesQuery(undefined, { refetchOnMountOrArgChange: true });

/** La rotta della partita: «Riprendi» chiede un ticket NUOVO come sempre. */
const rottaTavolo = (tableId: string): string => `/scopa/tavolo/${tableId}`;

/**
 * «I MIEI TAVOLI / RIPRENDI» della scopa: la lobby comune (`components/gamehost/TavoliMiei.tsx`) consumata col gioco come parametro, senza copiarla. I testi sono del catalogo `scopa`
 * (it, en, es, el); `nomeTavolo(posti)` rende il formato: la scopa (2 posti), lo scopone (4), «Tavolo» per un numero di posti che la scopa non conosce. Il disegno e quello di sempre:
 * lo prova `tests/gamehost-tavoli-miei-parita.test.tsx` contro l'oracolo congelato prima della migrazione.
 */
export function TavoliMieiScopa() {
  const { t } = useTranslation('scopa');
  const etichette: EtichetteTavoli = {
    titolo: t('hub.tavoli.titolo'),
    vuoto: t('hub.tavoli.vuoto'),
    inCorso: t('hub.tavoli.inCorso'),
    inAttesa: t('hub.tavoli.inAttesa'),
    riprendi: t('hub.tavoli.riprendi'),
    riprova: t('hub.tavoli.riprova'),
    guasto: { 'non-disponibile': t('hub.tavoli.guasto.non-disponibile'), rete: t('hub.tavoli.guasto.rete'), errore: t('hub.tavoli.guasto.errore') },
    nomeTavolo: (posti) => (posti === POSTI_SCOPONE ? t('modo.scopone') : posti === POSTI_SCOPA ? t('modo.scopa') : t('hub.tavoli.tavolo')),
  };
  return <TavoliMiei useTavoli={useTavoli} rottaTavolo={rottaTavolo} etichette={etichette} />;
}
